// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6m-0";
export var startPickingButton = "_6m-1";